<template>
  <div class="clear-time-list">
    <!-- CLEAR TIME LIST HEADER -->
    <div class="d-flex flex-column gap-2">
      <div class="d-flex gap-2 align-items-center flex-wrap">
        <div class="queue-header-text">Select Clear Times</div>
        <hr
          class="queue-header-horizontal-line flex-grow-1 align-self-center"
        />
      </div>
      <span class="text-muted">
        Use toggle to choose timings for all queues to clear (All queues get
        cleared on 12 AM)
      </span>
    </div>
    <!-- CLEAR TIME LIST HEADER -->

    <!-- CLEAR TIME LIST WHEN LOADING IS DONE -->
    <div
      v-if="!isInitialListLoading"
      class="scrollable-list ps__child--consume"
      :class="{
        'queue-loading': isLoading
      }"
    >
      <template v-if="listWithSwitchAll.length > 0">
        <ClearTimeListItem
          v-for="item in listWithSwitchAll"
          :key="item.id"
          :item="item"
          :is-currently-getting-edited="checkIfCurrentlyGettingEdited(item)"
          @edit="onEdit"
          @delete="onDelete"
          @toggle="onToggle"
        />
      </template>
      <template v-else>
        <div
          class="d-flex w-full py-3 rounded bg-white justify-content-center align-items-center flex-column gap-2"
        >
          <span class="text-muted">
            You have not scheduled any clear times yet
          </span>
        </div>
      </template>
    </div>
    <!-- CLEAR TIME LIST WHEN LOADING -->
    <div
      v-else
      class="justify-content-center align-content-center rounded-30 mt-6 d-flex gap-2 flex-grow-1"
    >
      <CSpinner color="primary" />
    </div>
    <!-- CLEAR TIME LIST WHEN LOADING -->
  </div>
</template>

<script>
import ClearTimeListItem from "@/v3components/Queue/QueueTime/ClearTimeListItem.vue"
import { ref, onMounted, watch, computed } from "vue"
import { useStore } from "vuex"

export default {
  name: "ClearTimeList",
  components: {
    ClearTimeListItem
  },
  setup() {
    const store = useStore()

    const serverError = ref(null)
    const isInitialListLoading = ref(true)
    const isLoading = ref(false)

    const list = ref([])

    const updateClearTimeList = computed(() => {
      return store.getters["queueSettings/updateClearTimeList"]
    })

    const listWithSwitchAll = computed(() => {
      if (list?.value?.length > 0) {
        return [
          {
            id: "switch-on-all",
            isSwitchAll: true,
            label: areAllSwitchOn?.value ? "Switch off all" : "Switch on all",
            status: areAllSwitchOn?.value
          },
          ...list.value
        ]
      }
      return []
    })

    const areAllSwitchOn = computed(() => {
      return list?.value?.every((item) => item?.status)
    })

    const clearTimeToEdit = computed(() => {
      return store.getters["queueSettings/clearTimeToEdit"]
    })

    const checkIfCurrentlyGettingEdited = (item) => {
      return item?.id === clearTimeToEdit?.value?.id
    }

    const getClearTimes = async () => {
      try {
        isLoading.value = true
        const data = await store.dispatch("queueSettings/getClearTimes")
        list.value = data
      } catch (error) {
        serverError.value = error
      } finally {
        isLoading.value = false
      }
    }

    const onEdit = async (item) => {
      store.commit("queueSettings/setClearTimeToEdit", item)
    }

    const onDelete = async (item) => {
      try {
        isLoading.value = true
        await store.dispatch("queueSettings/deleteClearTime", item?.id)
        await getClearTimes()
      } catch (error) {
        serverError.value = error
      } finally {
        isLoading.value = false
      }
    }

    const onToggle = async (item) => {
      try {
        isLoading.value = true
        await store.dispatch("queueSettings/toggleClearTime", item)
        await getClearTimes()
      } catch (error) {
        serverError.value = error
      } finally {
        isLoading.value = false
      }
    }

    onMounted(async () => {
      isInitialListLoading.value = true
      await getClearTimes()
      isInitialListLoading.value = false
    })

    watch(
      () => updateClearTimeList?.value,
      async (newValue) => {
        if (newValue) {
          await getClearTimes()
          store.commit("queueSettings/setUpdateClearTimeList", false)
        }
      }
    )

    return {
      listWithSwitchAll,
      serverError,
      isInitialListLoading,
      isLoading,
      onEdit,
      onDelete,
      onToggle,
      checkIfCurrentlyGettingEdited,
      areAllSwitchOn,
      clearTimeToEdit,
      list,
      updateClearTimeList
    }
  }
}
</script>
